import { ApiError } from './client';

const KNOWN: Record<string, string> = {
  'plus-required': 'Para alunos, este módulo vem com o Plus.',
  'no-billing-profile': 'Preencha os dados de cobrança primeiro.',
  'billing-disabled': 'O pagamento online ainda está sendo ativado. Tente mais tarde.',
  'invalid-document': 'CPF inválido. Confira os números.',
  'invalid-pix-key': 'Chave Pix inválida para o tipo escolhido.',
  'no-pix-key': 'A pessoa ainda não cadastrou uma chave Pix.',
  'not-payable': 'Esta recompensa não está esperando pagamento.',
  'already-sent': 'Esta recompensa já foi enviada.',
  'no-plan': 'Você não tem um plano para cancelar.',
  'invalid-coupon': 'Este cupom não existe. Confira as letras e os números.',
  'own-coupon': 'Este é o seu próprio cupom. Passe ele para outras pessoas.',
  'already-referred': 'Você já foi indicado(a) por alguém.',
  'already-paying': 'O cupom só vale antes do primeiro pagamento.',
  'payment-provider-error': 'O Asaas recusou a operação. Veja os detalhes no painel do Asaas.',
};

/** Human message (pt-BR) for an API error. */
export function errorMessage(error: unknown, fallback = 'Não foi possível carregar os dados.') {
  if (error instanceof ApiError) {
    if (error.status === 0) return 'Sem conexão com o servidor.';
    if (error.code === 'quota-exceeded') return 'A cota deste recurso acabou neste período.';
    const details = (error.data as { details?: { personal?: boolean } } | null)?.details;
    if (error.code === 'module-disabled' && details?.personal) {
      return 'Ative este módulo na tela Módulos.';
    }
    if (error.code === 'module-disabled' || error.code === 'feature-disabled') {
      return 'Recurso fora do plano deste espaço.';
    }
    if (error.code === 'missing-permission') return 'Você não tem permissão para esta ação.';
    const known = KNOWN[error.code ?? ''];
    if (known) return known;
    if (error.status === 422) return error.message || 'Alguns campos estão inválidos.';
    return error.message || fallback;
  }
  return fallback;
}
